if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          button.addEventListener('click', () => this.activateMedia(button.dataset.modalMediaId));
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      activateMedia(mediaId) {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.dataset.mediaId === mediaId);
        });

        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.modalMediaId === mediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeMedia) activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.modalMediaId === activeMedia.dataset.mediaId);
        });
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
